import { render, staticRenderFns } from "./DocumentEcomForm.vue?vue&type=template&id=69700a2e&"
import script from "./DocumentEcomForm.vue?vue&type=script&lang=js&"
export * from "./DocumentEcomForm.vue?vue&type=script&lang=js&"
import style1 from "./DocumentEcomForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports